import { useCallback } from 'react'
import {
  updateLimitSwapPair,
  updateLimitSwapPairAmount,
} from '~/state/dex/actions'
import { useLimitSwapAmount, useLimitSwapPair } from '~/state/dex/hooks'
import { useAppDispatch } from '~/state/hooks'
import { batch } from 'react-redux'
import { useClearQueryParams } from './useInitTokenPairByRouter'

export const useDirectionChange = () => {
  const [inputToken, outputToken] = useLimitSwapPair()
  const { inputAmount, outputAmount } = useLimitSwapAmount()
  const dispatch = useAppDispatch()
  const clearQueryParams = useClearQueryParams()

  return useCallback(() => {
    if (inputToken && outputToken) {
      batch(() => {
        dispatch(
          updateLimitSwapPair({
            inputToken: outputToken,
            outputToken: inputToken,
          }),
        )
        dispatch(
          updateLimitSwapPairAmount({
            inputAmount: outputAmount,
            outputAmount: inputAmount,
          }),
        )
      })
      clearQueryParams()
    }
  }, [inputToken, outputToken, inputAmount, outputAmount, clearQueryParams])
}
